import { useEffect } from "react";

export const productPath = (p) => `/product/${p.slug || p.id}`;

const meta = (attr, key, val) => {
  let m = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!m) { m = document.createElement("meta"); m.setAttribute(attr, key); document.head.appendChild(m); }
  m.content = val;
};

export const setSeo = (title, desc) => {
  if (title) { document.title = title; meta("property", "og:title", title); meta("name", "twitter:title", title); }
  if (desc) { const d = desc.replace(/\s+/g, " ").trim().slice(0, 158); meta("name", "description", d); meta("property", "og:description", d); meta("name", "twitter:description", d); }
};

export const useSeo = (title, desc) => useEffect(() => { setSeo(title, desc); }, [title, desc]);

const SITE = process.env.REACT_APP_SITE_URL;
const abs = (u) => (u?.startsWith("/") ? SITE + u : u);

export const productSchema = (p, catName) => {
  const prices = p.variants?.length ? p.variants.map((v) => v.price) : [p.price];
  const inStock = (p.variants?.length ? p.variants.reduce((s, v) => s + (v.stock || 0), 0) : p.stock) > 0;
  const url = SITE + productPath(p);
  const offer = { "@type": prices.length > 1 ? "AggregateOffer" : "Offer", priceCurrency: "INR", url, availability: `https://schema.org/${inStock ? "InStock" : "OutOfStock"}`, itemCondition: "https://schema.org/NewCondition", seller: { "@type": "Organization", name: p.seller_name || "EAZYSHOPY" } };
  Object.assign(offer, prices.length > 1 ? { lowPrice: Math.min(...prices), highPrice: Math.max(...prices), offerCount: prices.length } : { price: p.price });
  return [
    { "@context": "https://schema.org", "@type": "Product", name: p.title, image: (p.images || []).map(abs), description: p.description || p.title, sku: p.id, ...(p.brand && { brand: { "@type": "Brand", name: p.brand } }), offers: offer,
      ...(p.reviews_count > 0 && p.rating > 0 && { aggregateRating: { "@type": "AggregateRating", ratingValue: p.rating, reviewCount: p.reviews_count, bestRating: 5, worstRating: 1 } }) },
    { "@context": "https://schema.org", "@type": "BreadcrumbList", itemListElement: [["Home", "/"], [catName || p.category, `/category/${p.category}`], [p.title, productPath(p)]].map(([name, path], i) => ({ "@type": "ListItem", position: i + 1, name, item: SITE + path })) },
  ];
};

export const useJsonLd = (data) => useEffect(() => {
  if (!data) return undefined;
  const s = document.createElement("script");
  s.type = "application/ld+json";
  s.dataset.page = "1";
  s.text = JSON.stringify(data);
  document.head.appendChild(s);
  return () => s.remove();
}, [JSON.stringify(data)]); // eslint-disable-line
